export const _LOAD_MODEL_ = 'Load:CostModel';
export const _RELOAD_TYPE_ = 'Reload:CostType';

export const _DELETE_COST_ = 'Delete:Cost';

export const _SAVE_COST_SUCCESS_ = 'Save:CostSuccess';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequestCost:Finished';

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  price: null,
};
